export class ListSelectedLoadAction {
  constructor(public items: Array<string>) {}
}
